// extracted by mini-css-extract-plugin
export default {"commonTabContainer":"customTab_commonTabContainer__MZF6C","commonTab":"customTab_commonTab__ZdUvf","linkName":"customTab_linkName__aJ-9D"};